import angular from 'angular';
import SalesConstantsController from './configuration.controller';

export default angular.module('autoboard.salesConstants', [])
  .controller('SalesConstantsController', SalesConstantsController)
  .name;
